import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { trackEvent } from "@/lib/apiClient";

export function BookButton({ to = "/book", children = "Book", className = "", small = false, onClick }) {
  return (
    <Link
      to={to}
      data-testid="book-cta"
      onClick={() => { trackEvent("book_button_click"); onClick && onClick(); }}
      className={`book-cta ${small ? "!px-5 !py-2.5 !text-[0.7rem]" : ""} ${className}`}
    >
      {children}
      <ArrowRight size={small ? 14 : 16} />
    </Link>
  );
}

export default BookButton;
